"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CTF_WEB_SERVICES_DOMAIN = exports.CAPTION_DUTCH = exports.SETUP_ERRORS = exports.DEVICE = exports.PLATFORM = exports.OS = exports.DRM_PROVIDERS = exports.PROGRAM_TYPE = exports.CLOUDINARY_BASE_URL = void 0;
exports.CLOUDINARY_BASE_URL = 'https://cldnr.talpa.network/talpa-network/image/fetch/';
exports.PROGRAM_TYPE = {
    EPISODE: 'EPISODE',
    CLIP: 'CLIP',
    MOVIE: 'MOVIE',
};
exports.DRM_PROVIDERS = {
    FAIRPLAY: 'fairplay',
    PLAYREADY: 'playready',
    WIDEVINE: 'widevine',
};
exports.OS = {
    IOS: 'ios',
    ANDROID: 'android',
};
exports.PLATFORM = {
    APP: 'app',
    WEB: 'web',
};
exports.DEVICE = {
    DESKTOP: 'desktop',
    MOBILE: 'mobile',
    TABLET: 'tablet',
    SMARTTV: 'smarttv',
};
exports.SETUP_ERRORS = {
    PLAYLIST_ERROR: 'Fetch playlist error',
    PLAYLIST_NO_RESULTS: 'Fetch playlist no results',
    EMPTY_PLAYLIST: 'Empty playlist',
    INVALID_SERIES: 'Fetch series no results',
};
exports.CAPTION_DUTCH = 'Nederlands';
exports.CTF_WEB_SERVICES_DOMAIN = 'ctf.prod.ws.talpa.digital';
